@let activatedStep = this.activatedStep();
@let steps = this.steps();
@let previouslyActivatedStep = this.previouslyActivatedStep();

@if (activatedStep) {
    <div class="steps" [style.max-width]="steps.length * 90 + (steps.length - 1) * 30 + 'px'">
        @for (step of steps; let i = $index; track step.url) {
            @let arePreviousStepsValid = this.arePreviousStepsValid(i);
            <div
                class="step"
                tabindex="0"
                [class.activated-from-left]="
                    activatedStep === step && (previouslyActivatedStep?.positionIndex ?? 0) <= step.positionIndex
                "
                [class.activated-from-right]="
                    activatedStep === step && (previouslyActivatedStep?.positionIndex ?? 0) > step.positionIndex
                "
                [class.active]="activatedStep === step"
                [class.deactivated-from-left]="
                    previouslyActivatedStep === step && step.positionIndex > activatedStep.positionIndex
                "
                [class.deactivated-from-right]="
                    previouslyActivatedStep === step && step.positionIndex < activatedStep.positionIndex
                "
                [class.valid]="arePreviousStepsValid"
                (click)="workflowStepChanged.emit(step)"
                (keydown.enter)="workflowStepChanged.emit(step)"
                (keydown.space)="workflowStepChanged.emit(step)"
            >
                <span class="circle-step-number">{{ i + 1 }}</span>
                @if (activatedStep !== step) {
                    <span class="static-border"></span>
                    @if (arePreviousStepsValid) {
                        <span class="animated-border"></span>
                    }
                }
            </div>
        }
    </div>
}
